import { ScheduleResultModel } from '@em/models/restapi/ScheduleResult.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class ScheduleResultCollectionModel extends CollectionModel<ScheduleResultModel> {
    public constructor() {
        super(ScheduleResultModel);
    }
}
